module.exports = __webpack_public_path__ + "img/tips-insurance-icon.5bc23b8b.svg";